import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row, Button, Spinner } from 'react-bootstrap';
import { Icon } from '../../components';
import { showSurveyRequest } from '../../requests/surveys';
import { showEmployeeSurveyRequest } from '../../requests/employeeSurveys';
import basicSurvey from '../Survey/survey';
import SurveyPreview from '../Survey/SurveyPreview';
import { camelCaseEmptyStringRecursive } from '../../services/utils';

const EmployeeSurveyShow = ({ match }) => {
  const { id } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();
  const [onRequest, setOnRequest] = useState(true);
  const [survey, setSurvey] = useState(basicSurvey);
  const [employeeSurvey, setEmployeeSurvey] = useState({ employeeQuestionChoicesAttributes: [] });

  const fetchEmployeeSurvey = () => {
    setOnRequest(true);
    const request = async () => {
      showEmployeeSurveyRequest(id, {
        dispatch,
        successCallback: response => setEmployeeSurvey(camelCaseEmptyStringRecursive(response.data)),
        callback: () => setOnRequest(false)
      });
    };
    request();
  };

  const fetchSurvey = () => {
    if (employeeSurvey.survey?.value) {
      setOnRequest(true);
      const request = async () => {
        showSurveyRequest(employeeSurvey.survey.value, {
          dispatch,
          successCallback: response => setSurvey(camelCaseEmptyStringRecursive(response.data)),
          callback: () => setOnRequest(false)
        });
      };
      request();
    }
  };

  useEffect(fetchEmployeeSurvey, [id]);
  useEffect(fetchSurvey, [employeeSurvey]);

  return (
    <div className={`${onRequest && 'bg-opacity'}`}>
      {onRequest && (
        <div className="containerSpinnerLoad fix-middle center-spinner position-fixed">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      <Row className="my-4">
        <Button 
          variant="circle-dark" 
          className="btn-circle mt-3" 
          onClick={() => history.goBack()}
        >
          <Icon icon="chevron-back" />
        </Button>
        <h2 className="text-uppercase ml-1 mt-3 d-inline">{survey.name}</h2>
      </Row>
      {!onRequest && <SurveyPreview survey={survey} employeeSurvey={employeeSurvey} />}
    </div>
  );
};

export default EmployeeSurveyShow;
